<template>
  <div class="editDialog editUserDialog" @click="onClose">
    <div class="editMain" @click="((event)=>onItemClick(event))">
      <div v-if="dialogType === 0" class="changeName" style="height: 232px">
        <div class="dialogTitle" style="margin-bottom: 20px">{{$t("accountEditTitle")}}</div>
        <PDFInput ref="nameRef" refName="nameInput" inputWidth="100%" inputHeight="40px" :defaultText="userInfo.nickName" :placeholderString="$t(`accountSetNickNamePlaceholder`)" :inputMaxLength="12" :isShowNumber="true" @handleChange="onCheck"/>
        <div class="bottom">
          <PDFStatsButton :title="$t(`cancel`)" :color="`#ffffff`" textColor="#2690E1" customFontSize="14px" paddingTop="0 0" :borderStyle="'#2690E1 solid 1px'" paddingH="0 0"  @ButtonClick="onClose"/>
          <div style="width: 20px" />
          <PDFStatsButton :title="$t(`edit`)" :isDisable="isBtnDisable" :color="isBtnDisable ? `#D3E9F9` : `#2590E1`" textColor="white" :borderStyle="isBtnDisable ? '#D3E9F9 solid 1px' : '#2690E1 solid 1px'" customFontSize="14px" paddingTop="0 0" paddingH="0 0"  @ButtonClick="onEdit"/>
        </div>
      </div>
      <div v-if="dialogType === 1" class="changePassword" :style="`height:${!userInfo.setPasswordWarn ? '433px' : '350px'} `">
        <!-- 设置密码 / 忘记密码 的title -->
        <div v-if='setOrforget === 1' class="dialogTitle">{{$t("accountSetPassword")}}</div>
        <div class="backBtn" v-if="setOrforget === 2">
          <i class="iconfont icon-icon_return backBtn_icon" @click="onBackSetPassword" />
          <div class="dialogTitle">{{$t("LoginForget").replace(/\?/g, '') }}</div>
        </div>
        <!-- 当前登录的邮箱账号 -->
        <div class="title">{{$t("LoginEmail")}}</div>
        <PDFInput ref="nameRef" :class="{'setMarginBottom':setOrforget === 2}" :isDisable="true" :defaultText="accountEmail" inputWidth="100%" inputHeight="40px" :placeholderString="$t(`accountSetNickNamePlaceholder`)"/>
        <!-- 忘记原密码按钮 -->
        <div class="password" v-if="!userInfo.setPasswordWarn && setOrforget === 1">
          <div class="title1">{{$t("accountOldPassword")}}</div>
          <div class="subTitle" @click="onForget">{{$t("accountForgetPassword")}}</div>
        </div>
        <!-- 获取邮箱验证码 -->
        <div class="loginItem" v-show="setOrforget === 2">
          <div class="loginTitle1">
            {{ $t("LoginEmailCode") }}
          </div>
          <PDFInput ref="codeRegistRef" :isCodeClick="isAccountEmailValidString" inputWidth="100%"
            inputHeight="40px" :placeholderString="$t(`LoginCodePlaceholder`)" :inputMaxLength="6" :isCode="true"
            @handleChange="onCheck" @sendCode="onRegistCode" :isSendCode="isSendCode"/>
        </div>

        <PDFInput v-if="!userInfo.setPasswordWarn&& setOrforget === 1" ref="oldPasswordRef" inputWidth="100%" inputHeight="40px" :placeholderString="$t(`accountSetOldPasswordPlaceholder`)" :inputMaxLength="64" :isPassword="true" :isShowNumber="true" @handleChange="onCheck"/>
        
        <div class="title">{{$t("accountNewPassword")}}</div>
        <PDFInput ref="passwordRef" inputWidth="100%" inputHeight="40px" :placeholderString="$t(`accountSetNewPasswordPlaceholder`)" :inputMinLength="8" :inputMaxLength="64" :isPassword="true" :isShowNumber="true" @handleChange="onCheck"/>
        <div class="bottom">
          <PDFStatsButton :title="$t(`cancel`)" :color="`#ffffff`" textColor="#2690E1" customFontSize="14px" paddingTop="0 0" :borderStyle="'#2690E1 solid 1px'" paddingH="0 0"  @ButtonClick="onClose"/>
          <div style="width: 20px" />
          <PDFStatsButton :title="$t(`edit`)" :isDisable="isBtnDisable" :color="isBtnDisable ? `#D3E9F9` : `#2590E1`" textColor="white" :borderStyle="isBtnDisable ? '#D3E9F9 solid 1px' : '#2690E1 solid 1px'" customFontSize="14px" paddingTop="0 0" paddingH="0 0"  @ButtonClick="onEdit"/>
        </div>
      </div>
      <div v-if="dialogType === 2" class="changePassword" style="height: 232px">
        <div class="dialogTitle" style="margin-bottom: 20px">{{ userInfo.email ? $t("edit") : $t("setting")}}</div>
        <PDFInput ref="nameRef" refName="emailInput" :defaultText="userInfo.email" inputWidth="100%" inputHeight="40px" :placeholderString="$t(`accountSetNickNamePlaceholder`)"/>
        <div class="bottom">
          <PDFStatsButton :title="$t(`cancel`)" :color="`#ffffff`" textColor="#2690E1" customFontSize="14px" paddingTop="0 0" :borderStyle="'#2690E1 solid 1px'" paddingH="0 0"  @ButtonClick="onClose"/>
          <div style="width: 20px" />
          <PDFStatsButton :title="$t(`save`)" :isDisable="isBtnDisable" :color="isBtnDisable ? `#D3E9F9` : `#2590E1`" textColor="white" :borderStyle="isBtnDisable ? '#D3E9F9 solid 1px' : '#2690E1 solid 1px'" customFontSize="14px" paddingTop="0 0" paddingH="0 0"  @ButtonClick="onEdit"/>
        </div>
      </div>
      <!-- 删除账号 -->
      <div class="changePassword" v-if="dialogType === 4" style="min-height: 232px; padding-bottom: 20px;"
      @click="((event) => onItemClick(event))">
        <div class="loginOut">
          <div class="dialogTitle">{{ $t("accountLoginOutTip1") }}</div>
          <div class="subTitle" style="margin-top: 20px">{{ $t("accountSignOutTips_free") }}</div>
          <div class="loginInput">
            <input type="text" class="chooseSelectInput" :placeholder="`${$t('log_off_placeholder')}`"
              v-model="logOffValue" />
          </div>
        </div>
        <div class="bottom">
          <PDFStatsButton :title="$t(`accountLoginOutBtn1`)" :color="`#ffffff`" textColor="#2690E1" customFontSize="14px" paddingTop="0 0" :borderStyle="'#2690E1 solid 1px'" paddingH="0 0"  @ButtonClick="onClose"/>
          <div style="width: 20px" />
          <PDFStatsButton :isDisable="logOffValue.toUpperCase() != 'YES'" :title="$t(`confirm`)"
          :color="`${logOffValue.toUpperCase() != 'YES' ? '#D3E9F9' : '#2590E1'}`" textColor="white"
          :borderStyle="`${logOffValue.toUpperCase() != 'YES' ? '#2690E1 solid 0px' : '#2690E1 solid 1px'}`"
          customFontSize="14px" paddingTop="0 0" paddingH="0 0" @ButtonClick="(() => onSignOut())" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import PDFInput from "@/components/Index/components/input/PDFInput.vue"
import PDFButton from "@/components/Button/PDFButton.vue"
import PDFStatsButton from "@/components/Button/PDFStatsButton.vue"
import useUserStore from "@/store/modules/user";
// import {
//   getEmailAccountRegist,
//   getRequestAccountInfoEdit,
//   getEmailAccountCode,
//   getEmailAccountForget,
//   getRequestAccountUserInfo
// } from "../net/upload"
import UserServer from "@/services/UserServer";
import {storeToRefs} from "pinia";
import {defineEmits} from "vue";
import { getReplaceByString } from "@/utils/format";
import Toast from "@/utils/toast";
import {useI18n} from "vue-i18n";
import {useRouter} from "vue-router";
const { t } = useI18n()
const userStore = useUserStore();
const { userInfo, token} = storeToRefs(userStore);
const router = useRouter()

const props = defineProps({
  dialogType: {
    type: Number,  // 0 修改昵称 1 设置新密码 2 设置修改邮箱 3 用户取消订阅
  },
})

let call = defineEmits(["onClose"])
const nameRef = ref()
const oldPasswordRef = ref()
const passwordRef = ref()
const isBtnDisable = ref(false)
let logOffValue = ref("")
let accountEmail = userInfo.value.accountType == 1 ? getReplaceByString(userInfo.value.userAccount, "(google-oauth)") : userInfo.value.accountType == 2
    ? getReplaceByString(userInfo.value.userAccount, "(apple-oauth)") : userInfo.value.userAccount

console.log("getReplaceByString", accountEmail)

function onItemClick(e :Event) {
  e.stopPropagation()
}

function onClose() {
  call("onClose")
}

function onCheck() {
  if (props.dialogType === 0) {
    if (nameRef.value.inputValue.length > 0) {
      isBtnDisable.value = false
    }else {
      isBtnDisable.value = true
    }
  }else if (props.dialogType === 1) {

    if (userInfo.value.setPasswordWarn) {
      if (passwordRef.value.inputValue.length >= 8) {
        isBtnDisable.value = false
      }else {
        isBtnDisable.value = true
      }
    }else {
      if(setOrforget.value === 1 ){ // 设置密码
        if (oldPasswordRef.value.inputValue.length >= 6 && passwordRef.value.inputValue.length >= 8) {
          isBtnDisable.value = false
        }else {
          isBtnDisable.value = true
        }
      }else if(setOrforget.value === 2){  //忘记密码
        if (codeRegistRef.value.inputValue.length >= 6 && passwordRef.value.inputValue.length >= 8) {
          isBtnDisable.value = false
        }else {
          isBtnDisable.value = true
        }
      }
      
    }
  }
}

function onEdit() {
  if(setOrforget.value == 2){
    onForgetConfirm()
  }else{
    let param = {}
    if (props.dialogType === 0) {
      param.nickName = nameRef.value.inputValue
    }else if (props.dialogType === 1) {
      param.newPassword = passwordRef.value.inputValue
      if (!userInfo.value.setPasswordWarn) {
        param.oldPassword = oldPasswordRef.value.inputValue
      }
    }else if (props.dialogType === 2) {
      param.email = nameRef.value.inputValue
    }
    UserServer.getAccountInfoEdit(param).then((data)=> {
      if (data.code == "1") {
        if (props.dialogType === 0) {
          userInfo.value.nickName = param.nickName
        }else if (props.dialogType === 1){
          if (userInfo.value.setPasswordWarn) {
            userInfo.value.setPasswordWarn = false
          }else {
            router.replace({ path: '/'})
            userStore.tokenFail()
          }
        }else if (props.dialogType === 2) {
          userInfo.value.email = param.email
        }
        localStorage.setItem("user", JSON.stringify(userInfo.value))
        onClose()
        Toast(t("accountEditSuccess"));
      }else{
        Toast(data.message);
      }
    }).catch((error)=>{
      Toast(error.message);
    })
  }
  
}

function onForget() {
  const { href } = router.resolve({
    path: '/login/forget'
  });
  window.open(href, '_blank');
}

onMounted(()=>{
  onCheck()
})


let codeRegistRef = ref()
const setOrforget = ref(1);   // 设置密码：1  忘记密码：2
const onBackSetPassword = () => { 
  // 返回设置密码
  setOrforget.value = 1;
  isBtnDisable.value = true;
  clearInput()
  
}

const clearInput = () => {
  // 清空输入框
  if(oldPasswordRef.value){
    oldPasswordRef.value.inputValue = '';
  }
  if(passwordRef.value){
    passwordRef.value.inputValue = '';
  }
  if(codeRegistRef.value){
    codeRegistRef.value.inputValue = '';
  }
  
}

const isSendCode = ref(false)
// 获取验证码
function onRegistCode() {
  // 做正则校验邮箱是否合格
  if (!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(accountEmail)) {
    Toast(t("inputEmailTips1"))
    return;
  }
  isSendCode.value = true;
  let req = { sendType: 2, userEmail: accountEmail }

  UserServer.getAccountEmailCode(req).then((data) => {
    if (data.code == "1") {

    } else {
      Toast(data.message)
    }
  })
}
// 忘记密码的确认事件
const onForgetConfirm = () => {
  let req = { emailCheckCode: codeRegistRef.value.inputValue, newPassword: passwordRef.value.inputValue, userEmail: accountEmail }
  UserServer.getAccountForget(req).then((data) => {
    if (data.code == '1') {
      token.value = data.data
      getUserByToken()
      Toast(t("accountEditSuccess"));
      onClose()
    }
  }).catch((error) => {
    Toast(error.message);
  })
}
function getUserByToken() {
  userStore.getUserInfo().then((data)=> {
    if (data.code == '1') {
      // userInfo.value = data.data
      // localStorage.setItem("user", JSON.stringify(data.data))
      // document.body.style.overflow = 'auto'
    }
  }).catch((error)=>{
    Toast(error.message);
  })
}
function onSignOut() {
  UserServer.getDeleteAccount().then((data) => {
    if (data.code == '1') {
      userStore.tokenFail()
      router.replace({ path: '/' })
    }else{
      Toast(data.message)
    }
  })
}

const isAccountEmailValidString = computed(() => {
  return typeof accountEmail === 'string' && accountEmail.trim().length > 0;
});
</script>

<style scoped lang="scss">
.editDialog {
  flex-direction: column;
  width: 100%;
  height: 100vh;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0,0,0,0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9000;
}

.editMain {
  display: flex;
  width: 400px;
  background-color: white;
  border-radius: 8px;
  flex-direction: column;
  position: relative;
  align-items: center;
  .changeName {
    display: flex;
    flex-direction: column;
    }
    
    .bottom {
      display: flex;
      margin-top: 30px;
      flex-direction: row;
      align-items: center;
      height: 40px;
    }
    
    .dialogTitle {
      width: 100%;
      text-align: center;
      margin-top: 40px;
      font-size: 16px;
      font-weight: bold;
      color: var(--text-color);
    }
    
    .changePassword {
      display: flex;
      flex-direction: column;
      width: 90%;
    
      .loginOut {
        .loginInput {
          justify-content: center;
          align-self: center;
          display: flex;
          flex-direction: row;
          margin: 20px 20px 0 20px;
          width: calc(100% - 40px);
          height: 40px;
          border: 1px solid #BFBFBF;
          border-radius: 4px;
          &:hover {
            border: 1px solid #2590E1;
          }
          .chooseSelectInput {
            width: 100%;
            height: 40px;
            font-size: 12px;
            border: 0;
            /*清除自带的2px的边框*/
            padding: 0;
            /*清除自带的padding间距*/
            outline: none;
            /*清除input点击之后的黑色边框*/
            background-color: transparent;
            text-align: center;
          }

          input::-webkit-input-placeholder {
            /* placeholder颜色 */
            color: #BFBFBF;
            /* placeholder字体大小 */
            font-size: 12px;
            position: relative;
          }
        }
        .title {
          font-size: 16px;
          font-weight: bold;
          color: #262626;
        }

        .subTitle {
          font-size: 14px;
          color: #262626;
          text-align: center;
        }
      }
      .password {
        margin-top: 20px;
        height: 18px;
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    
        .title1 {
          font-weight: bold;
          font-size: 12px;
          color: var(--text-color);
        }
    
        .subTitle {
          height: 16px;
          font-size: 12px;
          color: var(--progress-bg-color);
    
          &:hover {
            border-bottom: 0.5px solid #2590E1;
            cursor: pointer;
          }
        }
      }
    
      .title {
        margin-top: 20px;
        margin-bottom: 10px;
        font-weight: bold;
        font-size: 12px;
        color: var(--text-color);
      }
    }
  .backBtn{
    position: relative;
    .backBtn_icon{
      color:var(--progress-bg-color);
      position: absolute;
      left:0;
      bottom:0;
      font-size: 20px;
    }
  }
  .setMarginBottom{
    margin-bottom:20px;
  }
  .loginTitle1{
    margin-bottom:10px;
  }
}
    
</style>
<style>
.editUserDialog input {
  font-size: 16px !important;
  /* 设置字体大小 */
}

.editUserDialog textarea {
  font-size: 16px !important;
  ;
  /* 设置字体大小 */
}
</style>
